import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import { ERROR } from '@/configs/constants';
import { ECOM_STATIC_CONTENT } from '@/configs/ecom/apis';
import dlv from 'dlv';
import seoResponseTransform from '@/utils/seoResponseTransform';

export const getStaticContent = async (url: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(ECOM_STATIC_CONTENT), {
      params: {
        url,
        'populate[layout][populate]': 'image,mobileImages,desktopImages,mobileImage,desktopImage',
        populate: 'seo',
      },
    });

    const data = dlv(response, 'data.data.attributes', {});
    seoResponseTransform(data.seo);
    return data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
